import { render, staticRenderFns } from "./detailConnection.vue?vue&type=template&id=b08b970a&scoped=true&"
import script from "./detailConnection.vue?vue&type=script&lang=js&"
export * from "./detailConnection.vue?vue&type=script&lang=js&"
import style0 from "./detailConnection.vue?vue&type=style&index=0&id=b08b970a&scoped=true&lang=scss&"
import style1 from "./detailConnection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b970a",
  null
  
)

export default component.exports